import AppButtonBook from '../app-button-book'

export default
{
    name: 'app-fixed-button-book',

    components:
    {
        AppButtonBook
    },

    data()
    {
        return {
            theForkId: '',
            label: '',
            isHidden: true
        }
    },

    created()
    {
        // Events
        this.eventHub.$on('restaurat:booking', this._onReceiveData)
        this.eventHub.$on('app-fixed-button-book:show', this._onShow)
        this.eventHub.$on('app-fixed-button-book:hide', this._onHide)
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('restaurat:booking', this._onReceiveData)
        this.eventHub.$off('app-fixed-button-book:show', this._onShow)
        this.eventHub.$off('app-fixed-button-book:hide', this._onHide)
    },

    methods:
    {
        // Events
        _onReceiveData(data)
        {
            this.theForkId = data.theForkId
            this.label = data.label
        },

        _onShow()
        {
            this.isHidden = false
        },

        _onHide()
        {
            this.isHidden = true
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-fixed-button-book/script.js